/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDataSourceRequest } from '../../models/create-data-source-request';
import { DataSourceDto } from '../../models/data-source-dto';

export interface DatasourcesPost$Json$Params {
      body?: CreateDataSourceRequest
}

export function datasourcesPost$Json(http: HttpClient, rootUrl: string, params?: DatasourcesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
  const rb = new RequestBuilder(rootUrl, datasourcesPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataSourceDto>;
    })
  );
}

datasourcesPost$Json.PATH = '/datasources';
